/**
 * FeedbackTile — Compact "we care" tile placed right under the WelcomeBanner.
 * Opens a Dialog with the full FeedbackForm. Keeps the dashboard tidy
 * while signalling that the team listens.
 */
import { useState } from "react";
import { MessageSquarePlus, ChevronRight } from "lucide-react";
import { Card, CardContent } from "@/components/ui/card";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { FeedbackForm } from "@/components/support/FeedbackForm";

export function FeedbackTile() {
  const [open, setOpen] = useState(false);

  return (
    <>
      <Card
        role="button"
        tabIndex={0}
        onClick={() => setOpen(true)}
        onKeyDown={(e) => {
          if (e.key === "Enter" || e.key === " ") {
            e.preventDefault();
            setOpen(true);
          }
        }}
        className="cursor-pointer hover:shadow-md transition-shadow border-primary/20 bg-gradient-to-r from-primary/5 to-transparent"
        style={{ touchAction: "manipulation" }}
      >
        <CardContent className="py-3 px-4 flex items-center gap-3">
          <div className="rounded-full bg-primary/10 p-2 shrink-0">
            <MessageSquarePlus className="h-4 w-4 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <p className="text-sm font-medium leading-tight">We're building this with you</p>
            <p className="text-xs text-muted-foreground truncate">
              Tap to share an idea, report a bug, or say hi.
            </p>
          </div>
          <ChevronRight className="h-4 w-4 text-muted-foreground shrink-0" />
        </CardContent>
      </Card>

      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent className="max-w-lg max-h-[90vh] overflow-y-auto">
          <DialogHeader>
            <DialogTitle>Share feedback with the team</DialogTitle>
          </DialogHeader>
          <FeedbackForm />
        </DialogContent>
      </Dialog>
    </>
  );
}

export default FeedbackTile;
